<template>
    <div style="min-width:900px;">
        <div class="pkg-search-box grow-creation-share-manage">
            <el-form class="pkg-content" label-position="left"
                     :model="dataForm"
                     @keyup.enter.native="getDataList()">
                <el-row class="margb10">
                    <el-col :span="7">
                        <!-- 标题 -->
                        <el-form-item label="标题"
                                      class="search-item">
                            <el-input v-model="dataForm.title"
                                      placeholder="请输入标题"></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- 所属公司简称 -->
                    <el-col :span="7">
                        <el-form-item label="所属公司简称"
                                      class="search-item">
                            <el-select v-model="dataForm.dealerId"
                                        remote
                                        clearable
                                        filterable
                                        reserve-keyword
                                        placeholder="请输入所属公司简称"
                                        :remote-method="parentDealerSearch">
                                <el-option v-for="item in parentDealerList"
                                        :key="item.orgId"
                                        :label="item.name"
                                        :value="item.orgId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <!-- 作品/提问/回答提交人 -->
                        <el-form-item label="提交人"
                                      class="search-item">
                            <el-input v-model="dataForm.worksSubmitter"
                                      placeholder="请输入ID/名字/员工号"></el-input>
                        </el-form-item>
                    </el-col>
                    <!-- 查询 -->
                    <el-col :span="3">
                        <el-col :span="24">
                            <el-button class="M-search"
                                       style="margin-bottom: 7px"
                                       type="primary"
                                       @click="getDataListMerge">查询</el-button>
                        </el-col>
                    </el-col>
                </el-row>
                <el-row class="margb10">
                    <el-col :span="7">
                        <!-- 职位团队分类 -->
                        <el-form-item label="职位团队分类" class="search-item">
                            <el-select v-model="dataForm.positionGroupType"
                                        placeholder="请选择"
                                        clearable>
                                <el-option v-for="(item,index) in positionGroupArr"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <!-- 职位名称 -->
                    <el-col :span="7">
                        <el-form-item label="职位名称" class="search-item">
                            <el-input v-model="dataForm.positionName"
                                        placeholder="请输入职位名称"
                                        clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <!-- 作品/提问/回答状态 -->
                        <el-form-item label="状态"
                                        class="search-item">
                            <el-select v-model="dataForm.workStatus"
                                        placeholder="请选择"
                                        clearable>
                                <el-option v-for="(item,index) in statusOptions"
                                        :key="index"
                                        :label="item.name"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <!-- 重置 -->
                        <el-col :span="24">
                            <el-button class="el-back M-search M-margin-l"
                                       type="info"
                                       @click="again">重置</el-button>
                        </el-col>
                    </el-col>
                </el-row>

                <!-- 高级搜索 --->
                <div v-show="moreList">
                    <el-row class="margb10">
                        <!-- 标签 -->
                        <el-col :span="7">
                            <el-form-item label="标签"
                                          class="search-item">
                                <el-input v-model="dataForm.tag"
                                          placeholder="请输入标签"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <!-- 作品/提问/回答审批人 -->
                            <el-form-item label="审批人"
                                        class="search-item">
                                <el-input v-model="dataForm.worksApprove"
                                        placeholder="请输入ID/名字/员工号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item label="话题" class="search-item">
                                <span slot="label">
                                  <el-link type="primary"
                                           :underline="false"
                                           @click="themeDataCon()">话题</el-link>
                                </span>
                                <el-input v-model="dataForm.themes"
                                          disabled
                                          placeholder="请选择"></el-input>
                                <!--<el-input v-model="dataForm.courseCode" v-show="false"></el-input>-->
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="margb10">
                    <el-col :span="7">
                      <!-- 类型 -->
                      <el-form-item label="类型"
                                    class="search-item">
                        <el-select v-model="dataForm.manageType"
                                   placeholder="请选择"
                                   clearable>
                          <el-option v-for="(item,index) in manageTypeOptions"
                                     :key="index"
                                     :label="item.name"
                                     :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>

                    <el-col :span="7">
                        <!-- 品牌 -->
                        <el-form-item label="所属品牌"
                                    class="search-item">
                            <el-select ref="brandSelectBox" v-model="dataForm.brands" clearable
                                    placeholder="请选择" multiple collapse-tags>
                                <el-option v-for="(item,index) in brands"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                  </el-row>
                    <el-row class="margb10">
                        <el-col :span="9">
                            <!-- 提交时间 -->
                            <el-form-item label="提交时间"
                                        class="search-item"
                                          style="width: 100% !important">
                                <el-date-picker v-model="submitTime"
                                                type="daterange"
                                                value-format="yyyy-MM-dd"
                                                start-placeholder="开始时间"
                                                end-placeholder="结束时间"
                                                :clearable="true"
                                                style="width: 100%">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                      <el-col :span="1"> &nbsp; </el-col>
                        <!-- 审批时间 -->
                        <el-col :span="9">
                            <el-form-item label="审批时间"
                                        class="search-item"
                                          style="width: 100% !important">
                                <el-date-picker v-model="approveTime"
                                                    type="daterange"
                                                    value-format="yyyy-MM-dd"
                                                    start-placeholder="开始时间"
                                                    end-placeholder="结束时间"
                                                    :clearable="true"
                                                    style="width: 100%">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </div>
            </el-form>
            <el-row style="text-align: center; margin-bottom: 10px;">
                <el-col :span="24">
                    <div class="show-or-hide-icon"
                         v-bind:class="{ 'el-icon-arrow-up': moreList,
                                         'el-icon-arrow-down': !moreList }"
                         @click="moreList = !moreList">&nbsp;{{ moreList ? '收起' : '高级搜索' }}
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="pkg-content">
            <el-table v-loading="dataListLoading"
                      :data="dataList"
                      tooltip-effect="dark"
                      border
                      :row-style="{height:48+'px'}"
                      :cell-style="{padding:0+'px'}">
                <!--序号-->
                <el-table-column label="序号"
                                 type="index"
                                 width="50"
                                 align="center"
                                 show-overflow-tooltip>
                    <template slot-scope='scope'><span>{{(page-1)*limit + scope.$index+1}}</span></template>
                </el-table-column>
                <!-- 类型 -->
                <el-table-column prop="manageType"
                                 label="类型"
                                 header-align="center"
                                 align="center"
                                 :formatter="manageTypeformat"
                                 width="80"
                                 show-overflow-tooltip></el-table-column>
                <!--标题-->
                <el-table-column prop="title"
                                 label="标题"
                                 header-align="center"
                                 align="left"
                                 width="160"
                                 show-overflow-tooltip></el-table-column>
                <!--所属公司简称-->
                <el-table-column prop="dealerAbbreviation"
                                 label="所属公司简称"
                                 header-align="center"
                                 align="left"
                                 width="120"
                                 show-overflow-tooltip></el-table-column>
                <!--作品/提问/回答提交人-->
                <el-table-column prop="worksSubmitterName"
                                 label="提交人"
                                 header-align="center"
                                 align="center"
                                 width="100"
                                 show-overflow-tooltip></el-table-column>
                <!--职位团队分类-->
                <el-table-column prop="positionGroupName"
                                 label="职位团队分类"
                                 header-align="center"
                                 align="center"
                                 width="120"
                                 show-overflow-tooltip></el-table-column>
                <!--职位名称-->
                <el-table-column prop="positionName"
                                 label="职位名称"
                                 header-align="center"
                                 align="center"
                                 width="140"
                                 show-overflow-tooltip></el-table-column>

                <!--品牌-->
                <el-table-column
                                 label="所属品牌"
                                 header-align="center"
                                 align="left"
                                 width="160"
                                 show-overflow-tooltip>
                                 <template slot-scope='scope'><span>{{brandsInfoListEdit(scope.row.brandsInfoList)}}</span></template>
                                 </el-table-column>
                <!--标签-->
                <el-table-column
                                 label="标签"
                                 header-align="center"
                                 align="left"
                                 width="160"
                                 show-overflow-tooltip>
                                 <template slot-scope='scope'><span>{{tagEdit(scope.row.tagList)}}</span></template>
                                 </el-table-column>
                <!-- 话题 -->
                <el-table-column prop="themeName"
                                 label="话题"
                                 header-align="center"
                                 align="center"
                                 width="140"
                                 show-overflow-tooltip></el-table-column>
                <!--提交时间-->
                <el-table-column prop="createTime"
                                 label="提交时间"
                                 header-align="center"
                                 align="center"
                                 width="160"
                                 show-overflow-tooltip></el-table-column>
                <!--作品/提问/回答审批人-->
                <el-table-column prop="approveUserName"
                                 label="审批人"
                                 header-align="center"
                                 align="center"
                                 width="100"
                                 show-overflow-tooltip></el-table-column>
                <!--审批时间-->
                <el-table-column prop="approveTime"
                                 label="审批时间"
                                 header-align="center"
                                 width="160"
                                 show-overflow-tooltip
                                 align="center"></el-table-column>
                <!--作品/提问/回答状态-->
                <el-table-column prop="workStatus"
                                 label="状态"
                                 header-align="center"
                                 show-overflow-tooltip
                                 :formatter="workstatusformat"
                                 width="100"
                                 align="center"></el-table-column>
                <!--操作-->
                <el-table-column label="操作"
                                 header-align="center"
                                 align="center"
                                 fixed="right">
                    <template slot-scope="scope">
                        <div>
                            <span class="el-dropdown-link" @click="showView(scope.row)">查看</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination :current-page="page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="limit"
                           :total="total"
                           layout="total, sizes, prev, pager, next, jumper"
                           @size-change="pageSizeChangeHandle"
                           @current-change="pageCurrentChangeHandle">
            </el-pagination>
        </div>
        <!-- 选择话题 -->
        <el-dialog title="选择话题"
                   :visible.sync="isShowThemeCon"
                   width="1100px">
            <div style="margin-top: 5px;">
                <el-row :gutter="5">
                    <!---------------- 左边 ----------------------->
                    <el-col style="width: 70%">
                        <el-card class="box-card">
                            <el-row style="height: 34px; margin-bottom: 20px">
                                <el-col :span="3">
                                    <p style="margin: 0; line-height: 34px">话题名称</p>
                                </el-col>
                                <el-col :span="11">
                                    <el-input v-model="themeTitle" :clearable="true"></el-input>
                                </el-col>
                                <el-col :span="10" style="text-align: right">
                                    <el-button type="primary" @click="findThemeCon()">查找</el-button>
                                </el-col>
                            </el-row>

                            <!-- 数据网格 -->
                            <div class="dataBox">
                                <el-table :data="themeListCon"
                                          ref="multipleTableCon"
                                          highlight-current-row
                                          border
                                          row-key="themeId"
                                          v-loading="dataListLoading"
                                          @select="selectRedio"
                                          @select-all="selectRedioAll">
                                    <el-table-column
                                                     type="selection"
                                                     header-align="center"
                                                     align="center"
                                                     disabled="true"
                                                     width="50">
                                    </el-table-column>
                                    <el-table-column prop="themeTitle"
                                                     label="话题名称"
                                                     width="324"
                                                     header-align="center"
                                                     show-overflow-tooltip
                                                     align="center"></el-table-column>
                                    <el-table-column prop="categoryName"
                                                     label="话题分类"
                                                     width="323"
                                                     header-align="center"
                                                     show-overflow-tooltip
                                                     align="center">
                                    </el-table-column>
                                </el-table>
                                <el-pagination @size-change="pageSizeChangeHandleCon"
                                               @current-change="pageCurrentChangeHandleCon"
                                               :current-page="pageCon"
                                               :page-sizes="[10, 20, 50, 100]"
                                               :page-size="limitCon"
                                               style="text-align: right"
                                               layout="total, sizes, prev, pager, next, jumper"
                                               :total="totalCon">
                                </el-pagination>

                            </div>
                        </el-card>
                    </el-col>

                    <!---------------------- 右边 ----------------------------------->
                    <el-col style="width: 30%;">
                        <el-card>
                            <div>
                                <el-form>
                                    <div class="location-layout">
                                        <el-row>
                                            <el-col style="width: 70%;height: 34px" align="left">
                                                <p>已选话题</p>
                                            </el-col>
                                            <el-col style="width: 30%;height: 34px">
                                                <el-button type="primary" @click="selectThemeCon(true)">选 择</el-button>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </el-form>
                            </div>
                        </el-card>
                        <el-row :gutter="10">
                            <el-col style="margin-top: 10px !important;" v-for="tag in themesCon"
                                    :key="tag.themeId">
                                <el-tag show-overflow-tooltip
                                        style="width: 100%;text-align: left"
                                        :key="tag.themeId"
                                        @close="handleClose(tag)"
                                        closable>
                                    <div style="width:90%;float:left;overflow-x:hidden; overflow-y:hidden; word-break:keep-all; white-space:nowrap;">{{tag.themeTitle}}</div>
                                </el-tag>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import mixinViewModule from '@/mixins/view-module'
    import Vue from 'vue'
    export default {
        name: "creationSharingManage",
        mixins: [mixinViewModule],
        data () {
            let _this = this
            return {
                mixinViewModuleOptions: {
                    getDataListURL: '/grow/cocreationsharingmanage/findPage',
                    getDataListIsPage: true
                },
                submitTime: '', // 提交时间
                approveTime: '', // 审批时间
                dataList: [],
                parentDealerList: [],
                positionGroupArr: _this.enums['group'], // 职位团队分类
                isDataForm: false,
                dataForm: {
                    title: '', // 标题
                    dealerId: '', // 所属公司简称
                    worksSubmitter: '', // 作品提交人
                    positionGroupType: '', // 职位团队分类
                    positionName: '', // 职位名称
                    workStatus: '', // 作品/提问/回答状态
                    tag: '', // 标签
                    worksApprove: '', // 作品/提问/回答审批人
                    beginSubmitTime: '', // 提交时间
                    endSubmitTime: '', // 提交时间
                    beginApproveTime: '', // 审批时间
                    endApproveTime: '', // 审批时间
                    themes: '',
                    collation: '4', //排序规则
                    manageType: '', //类型
                    brands:[]       // 品牌
                },
                // 等待转圈
                dataListLoading: false,
                moreList: false,
                statusOptions: [
                    {name: "待审核",
                     value: "10"},
                    {name: "已发布",
                     value: "20"},
                    {name: "未通过",
                     value: "30"},
                    {name: "已删除",
                     value: "40"},
                    {name: "已屏蔽",
                     value: "60"},
                ],
                manageTypeOptions: [
                  {name: "作品",
                    value: "1"},
                  {name: "提问",
                    value: "2"},
                  {name: "回答",
                    value: "3"}
                ],
                isShowThemeCon: false,
                themeName: '',
                themeTitle: '',
                showTag: false,
                themes: [],
                themesCon: [],
                themesConHistory: [],
                themeMultipleSelection: [],
                themeMultipleSelectionCon: [],
                themeList: [],
                themeListCon: [],
                page: 1,                    // 当前页码
                pageCon: 1,                    // 当前页码
                limit: 10,                  // 每页数
                limitCon: 10,                  // 每页数
                total: 0,
                totalCon: 0,
                themeId: '', //话题ID
                // 品牌
                brands:this.enums['brandCode'],
            }
        },
        components: {
        },
        methods: {
            // 查看
            showView (row) {
                this.$router.push({ path: 'grow-creationSharingShow', query: { id: row.id } })
            },
            // 查询
            getDataListMerge () {
                console.log(this.dataForm.brands);
                this.page = 1
                if (this.submitTime != null && this.submitTime !== '') {
                    this.dataForm.beginSubmitTime = this.submitTime[0]
                    this.dataForm.endSubmitTime = this.submitTime[1]
                }else {
                  this.dataForm.beginSubmitTime = ''
                  this.dataForm.endSubmitTime = ''
                }
                console.info(this.approveTime)
                if (this.approveTime != null && this.approveTime !== '') {
                    this.dataForm.beginApproveTime = this.approveTime[0]
                    this.dataForm.endApproveTime = this.approveTime[1]
                }else {
                  this.dataForm.beginApproveTime = ''
                  this.dataForm.endApproveTime = ''
                }
                if(this.dataForm.manageType==null){
                  this.dataForm.manageType = ''
                }
                this.isDataForm = true
                this.getDataList()
            },
            // 内容管理 分页, 每页条数
            pageSizeChangeHandle (val) {
                this.page = 1
                this.limit = val
                this.getDataList()
            },
            // 内容管理 分页, 当前页
            pageCurrentChangeHandle (val) {
                if (!this.isDataForm) {
                    this.dataForm = {
                        title: '', // 标题
                        dealerId: '', // 所属公司简称
                        worksSubmitter: '', // 作品/提问/回答提交人
                        positionGroupType: '', // 职位团队分类
                        positionName: '', // 职位名称
                        workStatus: '', // 作品/提问/回答状态
                        tag: '', // 标签
                        worksApprove: '', // 作品/提问/回答审批人
                        beginSubmitTime: '', // 提交时间
                        endSubmitTime: '', // 提交时间
                        beginApproveTime: '', // 审批时间
                        endApproveTime: '', // 审批时间
                        themes: '',
                        collation: '4', //排序规则
                        manageType: '' //类型
                    }
                    this.submitTime = ''
                    this.approveTime = ''
                }
                console.log(this.dataForm)
                this.page = val
                this.getDataList()
            },
            getDataList() {
                let newDataForm = JSON.parse(JSON.stringify(this.dataForm))
                if ('regionIds' in newDataForm) {
                    if (newDataForm.regionIds.length === 0) {
                        newDataForm.regionIds = ''
                    } else {
                        newDataForm.regionIds = newDataForm.regionIds.join(',')
                    }
                }
                this.dataListLoading = true
                this.$request.post(
                    this.mixinViewModuleOptions.getDataListURL,
                    {
                        order: this.order,
                        orderField: this.orderField,
                        page: this.mixinViewModuleOptions.getDataListIsPage ? this.page : null,
                        limit: this.mixinViewModuleOptions.getDataListIsPage ? this.limit : null,
                        params: this.dataForm
                    }
                ).then((res, total, code, data) => {
                    this.dataListLoading = false
                    let resultList = data.data.records
                    console.log(resultList);
                    this.dataList = !this.mixinViewModuleOptions.getDataListIsPage ? data.data : resultList
                    // this.dataList = resultList
                    this.total = this.mixinViewModuleOptions.getDataListIsPage ? data.data.total : 0
                }).catch(() => {
                    this.dataListLoading = false
                })
            },
            // 搜索所属公司简称
            parentDealerSearch(queryString) {
                this.$request.get('/sys/org/selectOrgList',
                {
                    name: queryString
                }).then((res, total, code, data) => {
                    this.parentDealerList = res
                    this.parentDealerList = this.parentDealerList.map(item => {
                    item['value'] = item.name
                    return item
                    })
                }).catch((err) => {
                    console.log(err)
                })
            },
            tagEdit(tagList) {
                let tagContent = ""
                if(tagList != null && tagList.length > 0) {
                    tagList.forEach(row =>{
                    tagContent = tagContent.concat(row.tagContent, ", ")
                })
                    return tagContent.substring(0, tagContent.length - 2)
                } else {
                    return ""
                }
            },
            brandsInfoListEdit(brandsInfoList){
                let content = ""
                if(brandsInfoList != null && brandsInfoList.length > 0) {
                    brandsInfoList.forEach(row =>{
                    content = content.concat(row.brandName, ", ")
                })
                    return content.substring(0, content.length - 2)
                } else {
                    return ""
                }
            },
            // 重置
            again () {
                this.page = 1
                this.limit = 10
                this.dataForm = {
                    title: '', // 标题
                    dealerId: '', // 所属公司简称
                    worksSubmitter: '', // 作品/提问/回答提交人
                    positionGroupType: '', // 职位团队分类
                    positionName: '', // 职位名称
                    workStatus: '', // 作品/提问/回答状态
                    tag: '', // 标签
                    worksApprove: '', // 作品/提问/回答审批人
                    beginSubmitTime: '', // 提交时间
                    endSubmitTime: '', // 提交时间
                    beginApproveTime: '', // 审批时间
                    endApproveTime: '', // 审批时间
                    themes: '',
                    collation: '4', //排序规则
                    manageType: '' //类型
                }
                this.submitTime = ''
                this.approveTime = ''
                this.isDataForm = false
                this.getDataList()
            },
            workstatusformat (row, column, cellValue) {
                if (cellValue === 10) {
                    return '待审核'
                } else if (cellValue === 20) {
                    return '已发布'
                } else if (cellValue === 30) {
                    return '未通过'
                } else if (cellValue === 40) {
                    return '已删除'
                } else if (cellValue === 60) {
                    return '已屏蔽'
                } else { return ' ' }
            },
            manageTypeformat (row, column, cellValue) {
              if (cellValue == '1') {
                return '作品'
              } else if (cellValue == '2') {
                return '提问'
              } else if (cellValue == '3') {
                return '回答'
              } else { return ' ' }
            },
            // 话题
            themeDataCon() {
                this.isShowThemeCon = true
                this.pageCon = '1'
                this.themeTitle = ""
                if (this.dataForm.themes.length <= 0) {
                    this.themesCon = []
                } else {
                    this.themesCon = JSON.parse(JSON.stringify(this.themesConHistory))
                }
                this.$nextTick(() => { this.$refs.multipleTableCon.clearSelection() })
                this.themeMultipleSelectionCon = []
                // 专区list取得
                this.getDataListCon()
                // if (this.themesCon) {
                //   this.themesCon.forEach(data => {
                //     this.themeListCon.forEach(row => {
                //       if(data.themeId === row.themeId) {
                //         this.$nextTick(() => {
                //           this.$refs.multipleTableCon.toggleRowSelection(row, true)
                //         })
                //       }
                //     })
                //   })
                // }
            },
            getDataListCon() {
                this.dataListLoading = true
                // 专区list取得
                this.$request
                    .get('/grow/theme/dialogFindPage', {
                        page: this.pageCon,
                        limit: this.limitCon,
                        themeTitle: this.themeTitle,
                        themeStatus: 20
                    })
                    .then((res, total, code, data) => {
                        this.themeListCon = data.data.records
                        // this.themeListCon.forEach((row) => {
                        //   row.themeTitle = data.data.userMap[row.createBy].themeTitle
                        // })
                        this.pageCon = data.data.current
                        this.limitCon = data.data.size
                        this.totalCon = data.data.total
                        if (this.themesCon && this.isShowThemeCon) {
                            this.themesCon.forEach(data => {
                                this.themeListCon.forEach(row => {
                                    if(data.themeId === row.themeId) {
                                        this.$nextTick(() => {
                                            this.$refs.multipleTableCon.toggleRowSelection(row, true)
                                        })
                                    }
                                })
                            })
                        }
                        this.dataListLoading = false
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            // 话题查找
            findThemeCon() {
                this.dataListLoading = true
                // 专区查找
                this.$request
                    .get('/grow/theme/dialogFindPage', {
                        page: 1,
                        limit: 10,
                        themeTitle: this.themeTitle,
                        themeStatus: 20
                    })
                    .then((res, total, code, data) => {
                        this.themeListCon = data.data.records
                        // this.themeListCon.forEach((row) => {
                        //   row.themeTitle = data.data.records[row.createBy].themeTitle
                        // })
                        this.pageCon = data.data.current
                        this.limitCon = data.data.size
                        this.totalCon = data.data.total

                        if (this.themesCon && this.isShowThemeCon) {
                            this.themesCon.forEach(data => {
                                this.themeListCon.forEach(row => {
                                    if(data.themeId === row.themeId) {
                                        this.$nextTick(() => {
                                            this.$refs.multipleTableCon.toggleRowSelection(row, true)
                                        })
                                    }
                                })
                            })
                        }
                        this.dataListLoading = false
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            // 单选
            selectRedio (selection, row) {
                // 判断当前点击的是打钩还是取消打钩 true 则是打勾
                let isSelected = this.isExistRow(selection, row, 'themeId')
                if (isSelected) {
                    // 勾选
                    this.themesCon.push(row)
                } else {
                    // 取消勾选
                    for (let i in this.themesCon) {
                        if (this.themesCon[i].themeId === row.themeId) {
                            this.themesCon.splice(i, 1)
                        }
                    }
                }
            },
            selectRedioAll (selection) {
                console.log("全选数据："+selection)
                if (selection) {
                    let courseDataB = []
                    courseDataB = this.themesCon
                    if (selection.length > 0) {
                        for (var i = 0; i < selection.length; i++) {
                            let hasFlg = false
                            if (courseDataB.length > 0) {
                                for (var l = 0; l < courseDataB.length; l++) {
                                    if (courseDataB[l].themeId.toString() === selection[i].themeId.toString()) {
                                        hasFlg = true
                                    }
                                }
                            }
                            if (!hasFlg) {
                                this.themesCon.push(selection[i])
                            }
                        }
                    } else {
                        if (this.themesCon.length > 0) {
                            this.themeListCon.forEach(item => {
                                let index = this.themesCon.findIndex(it => it.themeId.toString() === item.themeId.toString())
                                if (index != -1) {
                                    this.themesCon.splice(index,1)
                                }
                            })
                        }
                    }
                }
            },
            isExistRow: function isExistRow (arrs, row, field) {
                let flag = false
                arrs.forEach(function (item) {
                    if (row[field] === item[field]) {
                        flag = true
                    }
                })
                return flag
            },
            // 删除已选备件
            handleClose (data) {
                for (let a = 0; a < this.themeListCon.length; a++) {
                    // 这是需要用themeId做判断具有唯一性
                    if (data.themeId === this.themeListCon[a].themeId) {
                        this.$refs.multipleTableCon.toggleRowSelection(this.themeListCon[a], false)// 选择当前行
                        break
                    }
                }
                this.themesCon.splice(this.themesCon.indexOf(data),1)
            },

            // 分页, 每页条数
            pageSizeChangeHandleCon (val) {
                this.pageCon = 1
                this.limitCon = val
                this.getDataListCon()
            },
            // 分页, 当前页
            pageCurrentChangeHandleCon (val) {
                this.pageCon = val
                this.getDataListCon()
            },
            // 话题选择
            selectThemeCon(type) {
                this.dataForm.themes = ""
                this.themesConHistory = JSON.parse(JSON.stringify(this.themesCon))
                this.themesCon.forEach((element,index) => {
                    if (index == this.themesCon.length - 1) {
                        this.dataForm.themes += element.themeTitle
                    } else {
                        this.dataForm.themes += element.themeTitle + "/"
                    }
                });
                this.isShowThemeCon = false
            },
        },
        mounted() {
            this.$refs.brandSelectBox.initialInputHeight = 32;
        }
    }
</script>
<style lang="scss" scoped>
@import "../../css/pkg-styles.css";
.el-date-editor.el-input {
    width: 150px;
}
.search-item {
    width: 94%!important;
}
   .search-item .el-form-item__content {
        margin-left: 96px !important;
    }
.el-row {
    margin-bottom: 0px;
}
.search {
    height: 50px;
}
</style>
<style lang="scss">
.grow-creation-share-manage {
    .search-item .el-form-item__content {
        margin-left: 96px !important;
    }
}
</style>
